import { render, staticRenderFns } from "./StatisticOverviewPage.vue?vue&type=template&id=2c32c795"
import script from "./StatisticOverviewPage.vue?vue&type=script&lang=js"
export * from "./StatisticOverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports